import { CustomButton } from 'components/shared/CustomButton';
import { currencyByCountry, findPostiveNumber, findedLocation, isMobile, toAmount } from '../../helpers/Helper';
import { pageChange } from 'features/reducers/DocumentScan/PageChange.Reducer';
import { useTypedDispatch } from 'features/reduxhooks/ReduxHooks';
import React, { useEffect, useState } from 'react'
import { Card, CardBody, Col, Input, InputGroup, InputGroupText, Row } from 'reactstrap'
import CommonService from 'services/CommonService';

type inputProps = {
    orderPayout: any,
    referralCode: string,
    triggerOrderSummaryById: any,
    activeTab: any,
    setActiveTab: any
}


function Adjustment({ orderPayout, referralCode, triggerOrderSummaryById, activeTab, setActiveTab, ...rest }: inputProps) {

    let dispatch = useTypedDispatch();
    const [finalAdjusmentAmount, setFinalAdjustmentAmount] = useState<any>(0);
    const [finalAdjusmentAmountErr, setFinalAdjustmentAmountErr] = useState<any>(orderPayout?.TotalAmount);
    const submitError = "notValid";

    const save = () => {
        if (finalAdjusmentAmountErr !== submitError && finalAdjusmentAmountErr !== "") {
            let result = ((Number(finalAdjusmentAmount) + orderPayout?.Adjustment) - orderPayout?.TotalAmount);
            CommonService.postWithDoubleParam("Sell", 'AddAdjustment', 'orderId', orderPayout.OrderId, 'amount', result).then(res => {
                if (res.status === 200) {
                    triggerOrderSummaryById();
                    setActiveTab(4);
                    dispatch(pageChange("SignaturePad"));
                }   
            }).catch(e => {
                console.log(e);
            });
        }
        else {
            setFinalAdjustmentAmountErr(submitError);
        }
    };

    const updateTotalAmount = (value: any) => {
        if (value === "") {
            setFinalAdjustmentAmount(value);
            setFinalAdjustmentAmountErr(submitError);
        }
        else {
            setFinalAdjustmentAmountErr(value);
            setFinalAdjustmentAmount(value);
        }
    }

    useEffect(() => {
        setFinalAdjustmentAmount(orderPayout?.TotalAmount)
    }, [activeTab])

    return (
        <React.Fragment>
            <Card className='p-0'>
                <CardBody>
                    <div className='mb-3'>
                        <i className='fas fa-hashtag text-dofy me-2 font-size-15'></i>
                        <span className='font-size-16 fw-semibold text-dofy'>Order Payout</span>
                    </div>
                    <Row className='mb-2'>
                        <Col>
                            <h6 className=''>Selling Price</h6>
                        </Col>
                        <Col>
                            <h5 className='text-dofy fw-semibold' >{currencyByCountry(toAmount(Math.ceil(orderPayout?.SuggestedCost)))}/-</h5>
                        </Col>
                    </Row>
                    {orderPayout?.ReferralAmount ?
                        <Row className='mb-2'>
                            <Col>
                                <h6>Referral Bonus ({referralCode})</h6>
                            </Col>
                            <Col>
                                <h5 className='text-dofy fw-semibold' >{currencyByCountry(orderPayout?.ReferralAmount)}/-</h5>
                            </Col>
                        </Row> : null}
                    {(orderPayout?.RequoteAmount !== null && orderPayout?.RequoteAmount >= 0) ?
                        <Row className='mb-2'>
                            <Col>
                                <h6>Requote Diff.</h6>
                            </Col>
                            <Col>
                                <h5 className={`${findPostiveNumber(Math.ceil(orderPayout?.RequoteAmount as any) - Math.ceil(orderPayout?.SuggestedCost))}`}>{currencyByCountry(toAmount(Math.ceil(orderPayout?.RequoteAmount as any) - Math.ceil(orderPayout?.SuggestedCost)))}/-</h5>
                            </Col>
                        </Row> : null}
                    {orderPayout?.Adjustment !== 0 || ((Number(finalAdjusmentAmount) + orderPayout?.Adjustment) - orderPayout?.TotalAmount) !== 0 ?
                        <Row className='mb-2'>
                            <Col>
                                <h6>Adjustment</h6>
                            </Col>
                            <Col>
                                <h5 className={finalAdjusmentAmount ? findPostiveNumber(((Number(finalAdjusmentAmount) + orderPayout?.Adjustment) - orderPayout?.TotalAmount)) : findPostiveNumber(Math.ceil(orderPayout?.Adjustment as any))}>{currencyByCountry(finalAdjusmentAmount ? ((Number(finalAdjusmentAmount) + orderPayout?.Adjustment) - orderPayout?.TotalAmount) : toAmount(Math.ceil(orderPayout?.Adjustment as any)))}/-</h5>
                            </Col>
                        </Row> : null}
                    <Row className='mb-2'>
                        <Col>
                            <h6>Total</h6>
                        </Col>
                        <Col>
                            <h5 className='text-dofy fw-bold font-size-20'>{currencyByCountry(toAmount(orderPayout?.TotalAmount))}/-</h5>
                        </Col>
                    </Row>
                    <Row className='mb-3'>
                        <Col>
                            <h6>Paid Amount</h6>
                        </Col>
                        <Col>
                            <InputGroup>
                                <InputGroupText>
                                    <p className='text-dofy fw-semibold m-0 font-size-14'>
                                        {findedLocation().CountryCode == "in" ? "Rs." : "AED"}
                                    </p>
                                </InputGroupText>
                                <Input
                                    inputMode="numeric"
                                    type="text"
                                    pattern="\d*"
                                    value={finalAdjusmentAmount}
                                    onChange={(e) => 
                                        {const value = e.target.value;
                                        if (/^\d*$/.test(value)) {
                                        updateTotalAmount(value);
                                      }}}
                                    className={`Adjustment-field ${finalAdjusmentAmount && findedLocation().CountryCode == "in" ? "Adjustment-field-curruceny" : "Adjustment-field-curruceny-ae"}`}
                                />
                            </InputGroup>
                            {finalAdjusmentAmountErr === submitError ? <p className="text-danger">Please Fill Final Amount</p> : ""}
                        </Col>
                    </Row >
                    <Row className=''>
                        <Col>
                            {!isMobile() ?
                                  <div className='d-flex justify-content-end'>
                                  <CustomButton type={'button'} btnClassName={'btn-light me-2'} iconClasssName={''} name={'Previous'} onClick={() => { setActiveTab(2); dispatch(pageChange("UploadImagePage")) }} />
                                  <CustomButton type={'button'} btnClassName={'btn-success'} iconClasssName={undefined} name={'Save & Continue'} disabled={!finalAdjusmentAmount}  onClick={(e) => { save(); e.target.disabled = true;}} />
                              </div>:
                                 <div className='d-flex flex-column gap-2 '>
                                 <CustomButton type={'button'} btnClassName={'btn-light btn-lg w-lg'} iconClasssName={''} name={'Previous'} onClick={() => { setActiveTab(2); dispatch(pageChange("UploadImagePage")) }} />
                                 <CustomButton type={'button'} btnClassName={'btn-success btn-lg w-lg'} iconClasssName={undefined} disabled={!finalAdjusmentAmount} name={'Save & Continue'} onClick={(e) =>{ save(); e.target.disabled = true;}} />
                             </div>}
                        </Col>
                    </Row>
                </CardBody>
            </Card>
        </React.Fragment>
    )
}

export default Adjustment
